module.exports={
  message: {
    common:
    {
      update_successfully: 'update successfully'
    },
    header:
    {
		alarm: 'New alarms',
		see_alarm: 'See all alarms',
		search: 'Search',
		user_name: 'User name',
		setting: 'Account setting',
		logout: 'Logout',
		API:"API",
    },
    left:
    {
		navigation: 'Navigation',
		dashboard: 'Dashboard',
		live: 'Live',
		playback: 'Playback',
		AdvancePB:'AdvancePB',
		archive:"Archive",
		screenshots:"Folder",
		event:"Event",
		snapshot: 'Snapshot',
		setting: 'Setting',
		cloud: 'Cloud',
		logout: 'Logout',
		tour:"Tour",
		camera:"Camera",
		VideoConference:"Video Conference",
    },
    login:
    {
		high_perf: 'High performance HTML5 native video',
		signin: 'Sign In to Admin',
		login: 'LOG IN',
		login_status_failed: 'Username or Password not correct',
		username: 'USERNAME',
		password: 'PASSWORD',
		language: 'LANGUAGE'
				
    },
	dashboard:
    {
		about:"	About",
		dashboard: 'Dashboard',
		system_info: 'System Info',
		version: 'Version',
		hostid: 'Hostid',
		license: 'License',
		channel: 'Channel',
		endtime: 'Endtime',
		memory: 'Memory',
		running: 'Running',
		network_in: 'Network In',
		network_out: 'Network Out',
		an_out:"Network in and out",
		free_space: "Free Space",
		online_cam: "Online Cameras",
		cameras: "Cameras",
		total_space: "Total Space",
		codec_info: "Codec Info",
		GPU_info: "GPU info",
		cpumodel: 'CPU Model',
		gpuencoder:"GPU Encoders",
		gpudecoder:"GPU Decoders",
		PhysicalCPU:"Physical CPU",
		CPUCore:"CPU Core",
		cpuencoder:"Software Encoders",
		cpudecoder:"Software Decoders",
		capability:"Capability",
		devicesdk:"Device SDK",
		device:"Device",
		gb28181:"GB28181",
		devicesdkpb:"Device SDK Playback",
		transcoding:"Transcoding",
		VideoConference:"Video Conference",
		cluster:"Cluster",
		Online:"Online",
		Not_nline:"Not_nline",
		Platform:"Platform",
		Hikvision:"Hikvision",
		Dahua:"Dahua",
		Tiandy:"Tiandy",
		DiskMemory:"Disk/Memory",
		TotalMemory:"Total Memory",
		total:"Total ",
		ge:"",
		Cloud:"Cloud",
		RTMP:"RTMP push",
		Online:"Online",
		Offline:"Offline",
		Editorfailure:"Editor failure",
    },
	live:
    {
		liveview: 'Liveview',
		device: 'DEVICE',
		setting: 'SETTING',
		protocol: 'PROTOCOL',
		mainstream:'Main Stream',
		substream:'Sub Stream',
		camera:"Camera",
		waterprint:"Watermark",
		Videorecording:"Video recording",
		Region:"Region",
		Scan:"Scan to view video",
		Quality:"Quality",
		Switched:"Switched"
    },
    setting:
    {
		Default:"Default",
		Transcoding:"Transcoding",
		Profile:"Profile",
		setting: 'SETTING',
		device: 'Device',
		record: 'Record',
		devicesdk: 'Device SDK',
		devicertmppush: 'RTMP Push',
		Regional:"Region",
		Area:"Edit",
		Please:"Please enter a name",
		Input:"Input box cannot be empty",
		
		user: 'User',
		role: 'Role',
		action: 'Action',
		edit: 'Edit',
		name: 'Name',
		currentpass: 'Current Password',
		newpass: 'New Password',
		confirmpass: 'Confirm Password',
		manualstart:"Manual Start Record All Channel ",
		manualstop:"Manual Stop Record All Channel",
		DeleteAll:"Delete",
		Detail:"Detail",
		Cancel:"Cancel",
		OK:"OK",
		Configuration:"Configuration",
		ADD:"ADD",
		Change:"Change",
		Changecg:"Change successfully, please login again！",
		Changesb:"Change failed",
		Twopassword:"Two password are not same, please check!",
		all:"All",
	},
	table:{
		Token:"Token",
		Type:"Type",
		Online:"Online",
		Edit:"Edit",
		Index:"Index",
		GBID:"GBID",
		IP:"IP",
		Name:"Name",
		Port:"Port",
		User:"User",
		UUID:"UUID",
		Time:"Time",
		Detaill:"Detaill",
		Tokenevent:"Token",
		StartTime:"Start Time",
		EndTime:"End Time",
		Codec:"Codec",
		Engine:"Engine",
		FPSType:"FPSType",
		ScaleType:"ScaleType",
	},
	playback:{
		H5SPlayback:"H5S Playback",
		NVRPlayback:"NVR Playback",
	},
	GB:{
		name: 'Name',
		GB28181:"GB28181",
		GBPlatform:"GB Platform",
		Name:"Name",
		SIPServerIP:"SIP Server IP",
		SIPServerPort:"SIP Server Port",
		SIPPort:"SIP Port",
		SIPUserID:"SIP User ID",
		SIPServerID:"SIP Server ID",
		Password:"Password",
		SIPProtocol:"SIP Protocol",
		SIPChannelBaseID:"SIP Channel BaseID",
		RegisterPeriod:"Register Period",
		KeepaliveTime:"Keepalive Time",
		Domain:"Domain",
		Refreshsuccess:"Refresh success",
		Restartsuccessfully:"Restart successfully",

		DeleteAll:"DeleteAll",
		Detail:"Detail",
		Cancel:"Cancel",
		OK:"OK",
		Configuration:"Configuration",
		OVER:"OVER",
		ADD:"ADD",
		edit: 'Edit',

	},
	archive:{
		search: 'Search',
		archive:'Archive',
		StartTime:"Start Time",
		EndTime:"End Time",
		ManualRecord:"Manual Record",
		AlarmRecord:"Alarm Record",
		Schedulerecord:"Schedule record",
		Refresh:"Refresh",
		Download:"Download",
		Playback:"Playback",
		Name:"Name",
		Clear:"Clear",
		snapshot: 'Snapshot',
		Onehour:"One hour",
		Oneday:"One day",
		Oneweek:"One week",
		Onemonth:"One month",
		Time:"Time",
		Preview:"Preview",
		Picture:"Picture",
		Pleaseselectone:"Please select one",
	},
	tour:{
		Start:"Start",
		stop:"Stop",
	},
	camera:{
		Save_successfully:"Save successfully!",
		// Editor_failure:"Editorial_success!",
		Delete_successful:"Delete_successful!",
		Delete_failed:"Delete_successful！",
		open_Close:"Enable/Disable",
		name: 'Name',
		audio:"Audio" ,
		save:"Save",
	},
	Conference:{
		VideoConference:"Video Conference",
		Call:"Call",
		VideoCall:"Video Call",
		AudioCall:"Audio Call",
		HangUp:"Hang Up",
		Hang:"Hang",
		JoinConference:"Join Conference",
		Nickname:"Nickname cannot be empty!",
	}
  }
}



//////////////////
// WEBPACK FOOTER
// ./static/lang/en.js
// module id = AQny
// module chunks = 1